module.exports = "<div class=\"overlay hidden\"></div>\r\n";
